import React, {useState, useEffect} from 'react';
import {DatePicker, Form, Select} from "antd";
import moment from "moment";
import { getStocksAsSelect } from "../../../services/serviceStock";
import { getBrandsAsSelect } from "../../../services/serviceBrand";

const InvolvedBrandCluster = () => {
    const [stocks, setStocks] = useState([]);
    const [brands, setBrands] = useState([]);

    useEffect(() => {
        getStocksAsSelect()
            .then(({data}) => {
                if(data && data.length) {
                    const structured = data.map((item) => ({value: item.key, label:item.value}));
                    setStocks(structured);
                }
            })
    }, [])

    useEffect(() => {
        getBrandsAsSelect()
            .then(({data}) => {
                if(data && data.length) {
                    const structured = data.map((item) => ({value: item.key, label:item.label}));
                    setBrands(structured);
                }
            })
    }, [])

    const selectSearch = (input, option) => {
        return (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
    }

    const month = 30 * ( 24 * 60 * 60 * 1000 )
    const today = new Date()

    return(
        <React.Fragment>
            <Form.Item
                name={'startDate'}
                label={'Başlangıç Tarihi'}
                initialValue={moment(new Date(today - month))}
                rules={[
                    {required: true, message: 'Bu alan zorunludur'}
                ]}
            >
                <DatePicker format={'DD/MM/YYYY'} />
            </Form.Item>
            <Form.Item
                name={'endDate'}
                label={'Bitiş Tarihi'}
                initialValue={moment(new Date())}
                rules={[
                    {required: true, message: 'Bu alan zorunludur'}
                ]}
            >
                <DatePicker format={'DD/MM/YYYY'} />
            </Form.Item>
            <Form.Item
                name={'stockId'}
                label={'Stok Kodu'}
            >
                <Select showSearch options={stocks} filterOption={selectSearch} />
            </Form.Item>
            <Form.Item
                name={'brandId'}
                label={'Marka Adı'}
            >
                <Select showSearch options={brands} filterOption={selectSearch}/>
            </Form.Item>
        </React.Fragment>
    )
}
export default InvolvedBrandCluster